/* GLAMO: two-review preview + full Judge.me widget in an accessible modal.
   Only runs on product templates. Keeps Judge.me's original node and SSR HTML intact.
   Fail-open: if Judge.me's supported review-item markup is not detected, do nothing.
*/
(function () {
  "use strict";
  if (window.__glamoReviewCompactInitialized) return;
  window.__glamoReviewCompactInitialized = true;

  var SECTION_KEY = "glamo_judgeme_ai_reviews_20261027";
  var REVIEW_SELECTORS = [
    ".jdgm-rev",
    ".jm-review-item",
    ".jm-review-card",
    ".jm-review-list__item",
    ".jm-reviews-list__item",
    ".jm-review-widget__review",
    ".jm-review-widget__review-item",
    "[data-testid='review-item']"
  ].join(",");
  var WIDGET_SELECTORS = [
    ".jdgm-widget.jdgm-review-widget",
    ".jm-review-widget",
    ".jm-review-widget-v2025",
    "#judgeme_product_reviews",
    "[data-widget='review']",
    "[data-widget='review-v2025']"
  ].join(",");
  var LIMIT = 2;
  var language = (document.documentElement.lang || "lt").toLowerCase().split("-")[0];
  var i18n = {
    lt: {all:"Žiūrėti visus atsiliepimus", heading:"Visi atsiliepimai", close:"Uždaryti"},
    ru: {all:"Смотреть все отзывы", heading:"Все отзывы", close:"Закрыть"},
    en: {all:"View all reviews", heading:"All reviews", close:"Close"},
    uk: {all:"Переглянути всі відгуки", heading:"Усі відгуки", close:"Закрити"}
  };
  var t = i18n[language] || i18n.lt;

  function reviewCards(widget) {
    var nodes = Array.prototype.slice.call(widget.querySelectorAll(REVIEW_SELECTORS));
    return nodes.filter(function (node) {
      return !nodes.some(function (other) {
        return other !== node && other.contains(node);
      });
    });
  }

  function setup(section, widget) {
    if (widget.dataset.glamoReviewCompactReady === "true") return;
    widget.dataset.glamoReviewCompactReady = "true";

    var control = document.createElement("div");
    control.className = "glamo-review-compact-action";
    var opener = document.createElement("button");
    opener.type = "button";
    opener.className = "glamo-review-compact-button";
    opener.setAttribute("aria-haspopup", "dialog");
    opener.textContent = t.all + "  ›";
    opener.hidden = true;
    control.appendChild(opener);
    section.insertAdjacentElement("afterend", control);

    var dialog = document.createElement("dialog");
    dialog.className = "glamo-review-dialog";
    dialog.setAttribute("aria-label", t.heading);
    var frame = document.createElement("div");
    frame.className = "glamo-review-dialog-frame";
    var head = document.createElement("div");
    head.className = "glamo-review-dialog-header";
    var heading = document.createElement("h2");
    heading.textContent = t.heading;
    heading.id = "glamo-review-dialog-heading";
    dialog.setAttribute("aria-labelledby", heading.id);
    var close = document.createElement("button");
    close.type = "button";
    close.className = "glamo-review-dialog-close";
    close.setAttribute("aria-label", t.close);
    close.textContent = "×";
    head.appendChild(heading);
    head.appendChild(close);
    var slot = document.createElement("div");
    slot.className = "glamo-review-dialog-content";
    frame.appendChild(head);
    frame.appendChild(slot);
    dialog.appendChild(frame);
    document.body.appendChild(dialog);

    var marker = null;
    var previouslyFocused = null;
    var previousOverflow = "";
    var open = false;
    var updatePending = false;

    function updatePreview() {
      updatePending = false;
      var cards = reviewCards(widget);
      if (!cards.length) return;
      cards.forEach(function (card, index) {
        if (index >= LIMIT) {
          card.setAttribute("data-glamo-review-extra", "true");
        } else {
          card.removeAttribute("data-glamo-review-extra");
        }
      });
      var countEl = section.querySelector("[data-number-of-reviews]") ||
                    document.querySelector("#MainContent [data-number-of-reviews]");
      var count = countEl ? parseInt(countEl.getAttribute("data-number-of-reviews"), 10) : 0;
      opener.hidden = !(cards.length > LIMIT || count > LIMIT);
      if (!opener.hidden) widget.classList.add("glamo-review-compact-ready");
    }

    function requestPreviewUpdate() {
      if (updatePending) return;
      updatePending = true;
      window.requestAnimationFrame(updatePreview);
    }

    function restore() {
      if (!open) return;
      open = false;
      widget.classList.remove("glamo-reviews-modal-open");
      if (marker && marker.parentNode) {
        marker.parentNode.replaceChild(widget, marker);
      } else {
        section.appendChild(widget);
      }
      marker = null;
      document.documentElement.style.overflow = previousOverflow;
      requestPreviewUpdate();
      if (previouslyFocused && previouslyFocused.isConnected) {
        previouslyFocused.focus({preventScroll:true});
      } else {
        opener.focus({preventScroll:true});
      }
    }

    opener.addEventListener("click", function () {
      if (open || !dialog.showModal) return;
      previouslyFocused = document.activeElement;
      marker = document.createComment("Glamo Judge.me widget location");
      widget.parentNode.insertBefore(marker, widget);
      slot.appendChild(widget);
      widget.classList.add("glamo-reviews-modal-open");
      try {
        dialog.showModal();
        open = true;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = "hidden";
        frame.scrollTop = 0;
        close.focus({preventScroll:true});
      } catch (err) {
        widget.classList.remove("glamo-reviews-modal-open");
        if (marker && marker.parentNode) marker.parentNode.replaceChild(widget, marker);
        marker = null;
      }
    });

    close.addEventListener("click", function () { dialog.close(); });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("close", restore);
    // Keep Judge.me write-review actions operational outside our dialog:
    // third-party review forms may be portalled directly to document.body.
    dialog.addEventListener("click", function (event) {
      var element = event.target && event.target.closest ?
        event.target.closest("button,a,[role='button']") : null;
      if (!element || !slot.contains(element)) return;
      var klass = typeof element.className === "string" ? element.className : "";
      var label = (element.textContent || element.getAttribute("aria-label") || "").trim();
      var isWriteReview = /(?:^|[\s_-])write[\s_-]?(?:a[\s_-]?)?rev|write-review|write_review/i.test(klass) ||
        /^(write(?: a)? review|palikti atsiliepimą|parašyti atsiliepimą|rašyti atsiliepimą|написать отзыв|залишити відгук|leave a review)$/i.test(label);
      if (!isWriteReview) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.close();
      restore();
      window.setTimeout(function () {
        if (element.isConnected) element.click();
      }, 0);
    }, true);


    var observer = new MutationObserver(requestPreviewUpdate);
    observer.observe(widget, {childList:true, subtree:true});
    updatePreview();
  }

  function boot() {
    var tries = 0;
    var polling = window.setInterval(function () {
      tries++;
      var section = document.querySelector("[id*='" + SECTION_KEY + "']");
      if (!section) {
        if (tries >= 80) window.clearInterval(polling);
        return;
      }
      var widget = section.querySelector(WIDGET_SELECTORS);
      if (!widget || reviewCards(widget).length === 0) {
        if (tries >= 80) window.clearInterval(polling);
        return;
      }
      window.clearInterval(polling);
      setup(section, widget);
    }, 500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, {once:true});
  } else {
    boot();
  }
})();
